export default __webpack_public_path__ + "static/media/Heart.162e5776.svg";